import { getUserToken } from "../helpers/authHelper";
import api from "../api";

export async function GetEmployeeReferralList() {
  return await api({
    method: "get",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/employee-referral-list/`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}

export async function CreateReferralData(data) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/create-referral-data/`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-lang_id": localStorage.getItem("lang_id") || "1",
    },
    "content-type": "multipart/form-data",
  });
}

export async function GetReferralDataSingleRow(id) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/get-referral-data-row/${id}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}
export async function GetMasterCity() {
  let language = localStorage.getItem("lang_id");
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/getcity/city-listing?language_id=${language}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}
export async function UpdateReferralData(data, id) {
  return await api({
    method: "post",
    url: `${process.env.REACT_APP_API_URL}/admin/update-referral-data/${id}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      // "content-type": "multipart/form-data",
    },
    data: data,
  });
}

export async function DeleteReferralData(id) {
  return await api({
    method: "get",
    data: id,
    url: `${process.env.REACT_APP_API_URL}/admin/delete-referral-data/${id}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}
